import { memo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import deepEqual from 'fast-deep-equal/es6/react';
import TrapTabs from '../../../../atoms/trap-tabs';
import { ApplicationState } from '../../../../../store';
import { requestStudents } from '../../../../../store/dashboard/actions';
import { getActiveStageTab } from '../../../../../utilities/helpers';
import { useNavigate } from 'react-router-dom';
import { Title } from 'shared-components';
import { useTranslation } from "react-i18next";

export const TabsComp = ({ canViewNotInvitedTabs }: { canViewNotInvitedTabs?: boolean }) => {
    const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { invitedTabs, activeTab, isSearchActive, filterByMessage } = useSelector(
    ({ dashboard, ui }: ApplicationState) => {
      const params = new URLSearchParams(window.location.search);
      const isSearchActive = params.has('search') && (params.get('search') || '').length > 0;

      return {
        invitedTabs: dashboard.tabs,
        activeTab: getActiveStageTab(params, ui.headerTab),
        isSearchActive,
        filterByMessage: params.get('unread_messages') === 'true',
      };
    },
    deepEqual,
  );

  const filteredInvitedTabs = invitedTabs.filter(tab => tab.isNotInvited !== true);
  const notInvitedTabs = invitedTabs.filter(tab => tab.isNotInvited === true);

  const onTabSelect = useCallback(
    (id: string) => {
      const params = new URLSearchParams(window.location.search);
      params.set('page', '1');
      params.set('stage', id);
      navigate({ search: params.toString() });
      dispatch(requestStudents());
    },
    [dispatch],
  );

  const titleParams = new URLSearchParams(window.location.search);
  const pageNo = titleParams.get('page');
  const pageLabel = pageNo != null ? ` (page ${pageNo})` : '';
  const searchQuery = titleParams.get('search');
  const searchLabel = searchQuery != null ? `"${searchQuery}" search on ` : '';
  const pageTitle = `${searchLabel}${activeTab}${pageLabel}`;

  return (
    <>
      <Title title={pageTitle} />

      <TrapTabs
        tabs={filteredInvitedTabs}
        onTabSelect={onTabSelect}
        label={t('common:invited')}
        activeTab={activeTab}
        isSearchActive={isSearchActive}
        filterByMessage={filterByMessage}
        dataSelector="invited"
      />
      {notInvitedTabs.length > 0 && canViewNotInvitedTabs && (
        <TrapTabs
          tabs={notInvitedTabs}
          onTabSelect={onTabSelect}
          label={t('common:notInvited')}
          activeTab={activeTab}
          isSearchActive={isSearchActive}
          filterByMessage={filterByMessage}
          dataSelector="not-invited"
        />
      )}
    </>
  );
};

const propsAreEqual = (next: any, prev: any): boolean => deepEqual(prev, next);
export const Tabs = memo(TabsComp, propsAreEqual);
